import React, { Component } from 'react';
import './SubNavbar.css';
import { post, get, put, del } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, Typography, Box } from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import { Switch } from '@mui/material';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2f3541",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class SmsNotificationsSettings extends Component { 
  constructor(props) {
    super(props);
    this.state = {
      defaultEmailSaved: false, // Track if default email is saved
      // mob_numbers: [""], // 1 default email inputs
      
      mob_numbers: [   //for multiple email inputs now adding the alert email toggle and alert type selection in each block
          {
            countryCode: "+1", // Default country code: IND
            value: "",
            hdd_status_enabled: false,
            recording_status_enabled: false,
            device_status: false,
            rtsp_stream_enabled: false,
            true_threat_enabled: false,
            clear_alert_sms_enabled: false,

            // alerts: {
            //   person: false,
            //   vehicle: false,
            //   intruder: false
            // }
          }
        ],

      error: "",
      success: false,
      error2: false,
      error1: false,
      warning: false,
      success_report: false,
      warning_report: false,
      open_progress_bar: false,
      deviceId: "",
      devices: [],
      errordelete:"",
      mobNumberSaveError:"",
    };
  }

  componentDidMount() {
    localStorage.getItem(globalVariables.DEVICE_ID);
    this.setState({ deviceId: localStorage.getItem(globalVariables.DEVICE_ID) });
    this.fetchUserSettings(localStorage.getItem(globalVariables.DEVICE_ID));
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    this.setState({ user_type: storedUserType });
    
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.error !== prevState.error ||
      this.state.error1 !== prevState.error1 ||
      this.state.error2 !== prevState.error2 ||
      this.state.success !== prevState.success ||
      this.state.warning !== prevState.warning ||
      this.state.warning_report !== prevState.warning_report ||
      this.state.success_report !== prevState.success_report ||
      this.state.errordelete !== prevState.errordelete
    ) {
      if (
        this.state.error ||
        this.state.error1 ||
        this.state.error2 ||
        this.state.success ||
        this.state.warning ||
        this.state.warning_report ||
        this.state.success_report ||
        this.state.errordelete
      ) {
        setTimeout(() => {
          this.setState({
            error: false,
            success: false,
            error1: false,
            error2: false,
            warning: false,
            success_report: false,
            warning_report: false,
            errordelete: false,
          });
        }, 3000); // 3 second
      }
    }
  }

  handleDefaultEmailChange = (event) => {
    this.setState({ defaultEmail: event.target.value });
  };

  handleInputChange = (index, value) => {
  const mob_numbers = [...this.state.mob_numbers];
  mob_numbers[index].value = value;
  this.setState({ mob_numbers });
};

handleHddToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].hdd_status_enabled =
    !mob_numbers[index].hdd_status_enabled;

  this.setState({ mob_numbers });
};

handleRtspStreamToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].rtsp_stream_enabled =
    !mob_numbers[index].rtsp_stream_enabled;

  this.setState({ mob_numbers });
};

handleDeviceStatusToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].device_status =
    !mob_numbers[index].device_status;

  this.setState({ mob_numbers });
};

handleRordingStatusToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].recording_status_enabled =
    !mob_numbers[index].recording_status_enabled;

  this.setState({ mob_numbers });
};

handleTrueThreatAlertStatusToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].true_threat_enabled =
    !mob_numbers[index].true_threat_enabled;

  this.setState({ mob_numbers });
};

handleClearAlertStatusToggle = (index) => {
  const mob_numbers = [...this.state.mob_numbers];

  mob_numbers[index].clear_alert_sms_enabled =
    !mob_numbers[index].clear_alert_sms_enabled;

  this.setState({ mob_numbers });
};



  fetchUserSettings = async (devId) => {
    console.log("fetching user settings")
    // const {deviceId } = this.state;
        try {
          //   this.startLoading();
          let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth token---------", access_token);
          let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_token}`
          }
    
          
          const response = await get(urls.SAVE_SMS_NOTIFICATIONS_SETTING(devId), headers);
          console.log("API Response for fetch user settings:", response);
          
          const toBool = v => v === true || v === "true";
          let smsArray = [];
          if (response.status === true && Array.isArray(response.data)) {
            // const emailString = response || "";
            // const emailArray = emailString ? emailString.split(",").map(email => email.trim()) : [""];
            
             smsArray = response.data.map(e => ({
              id: e.id, // each email object has a unique 'id' field from the API
              countryCode: e.country_code || "+1", // Default to +91 if not provided             
              value: e.contact_number,
              hdd_status_enabled: toBool(e.hdd_status),
              recording_status_enabled: toBool(e.recording_days),
              device_status: toBool(e.device_status),
              rtsp_stream_enabled: false,
              true_threat_enabled: toBool(e.threat_alert),
              clear_alert_sms_enabled: toBool(e.clear_alert)
            }));
    
            this.setState({
              mob_numbers: smsArray,
            });
          }
    
          if (smsArray.length === 0) {
              smsArray = [
                {
                  // id: `temp-${Date.now()}`,
                  // isNew: true, // Marks as a local row only
                  countryCode: "+1", // Default country code: IND
                  contact_number: "",
                  device_status: false,
                  hdd_status: false,
                  recording_days: false,
                  rtsp_stream: false,
                }
              ];
              this.setState({
              mob_numbers: smsArray,
            });
            }
          
        } catch (error) {
          console.error("Error fetching user settings:", error);
           this.setState({error1:true});
        }
  };


  validateMobileNumber = (mobileNumber) => {
    // const mobileRegex = /^\d{10}$/;
    const mobileRegex = /^\d{7,15}$/; // for accepting all the international mob no.s
    return mobileRegex.test(mobileNumber);
  };

  handleSave = async () => {
    const { defaultEmail, mob_numbers, deviceId } = this.state;
    console.log("deviceId for mob no. to be saved===> ", deviceId, mob_numbers);

    // Filter out empty or whitespace-only mob_numbers
    // const hasEmptyMobNo = mob_numbers.some(email => email.trim() === "");
    const normalizedEmails = mob_numbers.map(e => ({
      ...e,
      value: e.value.trim()
    }));

    const hasInvalidMobNo = normalizedEmails.some(
      e => e.value !== "" && !this.validateMobileNumber(e.value)
    );
    const hasEmptyMobNo = normalizedEmails.some(e => e.value === "");

  // if (hasEmptyMobNo) {
  //   this.setState({ warning: true, mobNumberSaveError: "Mobile number field cannot be empty." });
  //   return;
  // }
    if (hasInvalidMobNo) {
      this.setState({
        warning: true,
        mobNumberSaveError: "Please enter a valid 10-digit mobile number."
      });
      return;
    }


    if ( !deviceId) {
      // alert("No mob_numbers provided. Emails not saved.");
      this.setState({ warning: true, mobNumberSaveError: "something went wrong, Cannot save the SMS settings" });
      return;
    }
    // Update state before saving
    this.setState({ mob_numbers}, async () => {
      const payload = {
        sms_alerts: this.state.mob_numbers.map(e => ({
        country_code: e.countryCode,
        contact_number: e.value,
        device_status: e.device_status,
        hdd_status: e.hdd_status_enabled,
        recording_days: e.recording_status_enabled,
        rtsp_stream: e.rtsp_stream_enabled,
        threat_alert: e.true_threat_enabled,
        clear_alert: e.clear_alert_sms_enabled
      }))
    };
    console.log("Payload to be sent to API===> ", payload);

    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
    // console.log("--------auth token---------", access_token);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    }
    console.log("--------headers---------", headers);
    let url = urls.SAVE_SMS_NOTIFICATIONS_SETTING(deviceId);
    console.log("--------API URL---------", url);
    let response = await post(urls.SAVE_SMS_NOTIFICATIONS_SETTING(deviceId), JSON.stringify(payload), headers);
    console.log("response of sms save===> ", response);
    this.stopLoading();
    if (response.status === true || response.message === "SMS Alerts created/updated successfully.") {
      // alert("Settings saved successfully.");
      this.setState({ success: true, defaultEmailSaved: true }, () => {
        this.fetchUserSettings(deviceId); // Refresh mob_numbers in UI
      });
    } 

    else {
      // alert("Error saving mob_numbers. Please try again.");
      this.setState({ error2: true });
    }
  });
  };


  startLoading = () => {
    this.setState({ open_progress_bar: true })
  }

  stopLoading = () => {
    this.setState({ open_progress_bar: false })
  }


 addEmailField = () => {
   if (this.state.mob_numbers.length >= 3) {
    this.setState({error: "Maximum 3 mobile numbers are allowed."});
    return;
  }
  this.setState((prev) => ({
    mob_numbers: [
      ...prev.mob_numbers,
      {
        id: `temp-${Date.now()}`,
        isNew: true, // Marks as a local row only
        countryCode: "+1", // Default country code: IND
        value: "",
        device_status: false,
        hdd_status_enabled: false,
        recording_status_enabled: false,
        rtsp_stream_enabled: false,
        true_threat_enabled: false,
        clear_alert_sms_enabled: false
      },
    ],
  }));
};

  handleCountryCodeChange = (index, code) => {
    const mob_numbers = [...this.state.mob_numbers];
    mob_numbers[index].countryCode = code;
    this.setState({ mob_numbers });
  };


  handleDropdownInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  
removeEmailField = (index) => {
  const { mob_numbers } = this.state;
  const emailToRemove = mob_numbers[index];

  if (!emailToRemove) return;

  // Identify if it is a record that exists on the server
  const isServerRecord = emailToRemove.isNew === false; 

  const updatedEmails = mob_numbers.filter((_, i) => i !== index);
  const finalEmails = updatedEmails.length > 0 ? updatedEmails : [this.getBlankRow()];

  this.setState({ mob_numbers: finalEmails }, () => {
    // Check if it was a saved record and has a value
    if (isServerRecord && emailToRemove.value?.trim()) {
      this.handleDeleteEmail(emailToRemove.value); 
    }
  });
};

getBlankRow = () => {
  return {
    id: `temp-${Date.now()}`,
    isNew: true, 
    value: "",
    chm_email_enabled: false,
    alerts_email_enabled: false,
    alerts: {
      person: false,
      vehicle: false,
      intruder: false
    }
  };
};

// handleDeleteEmail = async (index) => {
//   console.log("Attempting to delete email at index from DB:", index);
//   const { deviceId, mob_numbers } = this.state;

//   if (!deviceId) {
//     this.setState({
//       warning: true,
//       mobNumberSaveError: "Device not found. Cannot delete email."
//     });
//     return;
//   }
//   if (!index) {
//     this.setState({
//       warning: true,
//       mobNumberSaveError: "Device not found. Cannot delete email."
//     });
//     return;
//   }

//   const emailToDelete = mob_numbers[index];

//   if (!emailToDelete || !emailToDelete.value) {
//     return;
//   }

//   try {
//     this.startLoading();

//     let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

//     const payload = {
//       mob_numbers: [emailToDelete.value]
//     };

//     console.log("Deleting email payload =>", payload);

//     const response = await fetch(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId), 
//               { method: 'DELETE',
//               headers : {
//                   'content-type': 'application/json',
//                   'Authorization': `Bearer ${access_token}`
//               },
//               body: JSON.stringify(payload)
//               });

//     console.log("Delete response =>", response);

//     this.stopLoading();

//     if (response && response.status === 200) {
//       // ✅ Remove from UI after success
//       const updatedEmails = [...mob_numbers];
//       updatedEmails.splice(index, 1);

//       this.setState({
        
//         success: true
//       });
//     } else {
//       this.setState({
//         error2: true
//       });
//     }
//   } catch (error) {
//     console.error("Error deleting email:", error);
//     this.stopLoading();
//     this.setState({
//       error2: true
//     });
//   }
// };

handleDeleteEmail = async (emailValue) => { // Accept string, not index
  console.log("Attempting to delete email from DB:", emailValue);
  const { deviceId } = this.state;

  if (!deviceId || !emailValue) return;

  try {
    this.startLoading();
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const payload = {
      mob_numbers: [emailValue] // Use the passed string
    };

    const response = await fetch(urls.SMTP_ALERTS_DEVICE_SPECIFIC_EMAIL(deviceId), { 
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(payload)
    });

    this.stopLoading();

    if (response && response.status === 200) {
      this.setState({ success: true });
    } else {
      this.setState({ error2: true });
    }
  } catch (error) {
    console.error("Error deleting email:", error);
    this.stopLoading();
    this.setState({ error2: true });
  }
};  

  render() {
    const { mob_numbers, error, error2, success_report, warning_report, success, error1, warning, devices, deviceId, errordelete } = this.state;


    return (
      <ThemeProvider theme={darkTheme}> 
        <CssBaseline />
        <Box sx={{ backgroundColor:"#323744" }} >
          <Box  className="setting-container" style={{ width: '93%', alignItems:"center"}}>
            <div style={{ width: '100%' }}>
              {error2 ? (
                <Alert severity="error">Error saving mob_numbers. Please try again.!</Alert>
              ) : success ? (
                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                  "Settings saved successfully."
                </Alert>
              ) : success_report ? (
                <Alert severity="success">
                  "Sending demo report to: ${mob_numbers}"
                </Alert>
              ) : warning_report ? (
                <Alert severity="warning">
                  "Please enter valid mobile number(s) to send the SMS."
                </Alert>
              ) : errordelete ? (
                <Alert severity="error">
                  "At least one mobile number is required. You can disable the toggle, but cannot remove all mob_numbers."
                </Alert>
              ) : warning ? (
                <Alert severity="warning">
                  {this.state.mobNumberSaveError}
                </Alert>
              ) : null}
            </div>
            
            <Box component={Paper} style={{ display:"flex", fontSize: "13px", justifyContent:'space-between', marginBottom: "20px", width: '100%', border: "1px solid #ffffff36", borderRadius:"5px"}}>
              {/* <h3>Email addresses</h3> sx={{backgroundColor: "#313848", border: "1px solid #ffffff36", borderRadius:"5px"}}*/}
              <p style={{ padding:"5px" }}>
              <h4>Steps to follow:</h4>
                - Click (+ Add) to add more SMS recipients, one per field and (Save) the setting.<br/>
                - Click (-) to remove the mobile number field.<br/>
                
              </p>
              <p style={{ padding:"8px" }}>
                <h4>Settings Info. </h4>
                {/* <b>- Frequency: </b>First enter the frequency to receive the SMS based on the CHM schedule and/or while testing device connection<br/> */}
                <b>- HDD Status: </b>Enable to receive 'HDD status' updates<br/>
                <b>- 30 Days Recording Status: </b>Enable to receive '30 days recording status' error updates about cameras not meeting recording policy days<br/>
                <b>- Device Status: </b>Enable to receive 'offline' status updates of this device <br/>
                {/* <b>- RTSP Stream Status: </b>Enable to receive 'RTSP stream' updates when the stream is not working<br/> */}
              </p>
            </Box>
            <div style={{ width: '100%' }}>
              {error && <p style={{ color: "#f83838", fontSize: "14px" }}>{error}</p>}
              {/* <Box component={Paper} sx={{backgroundColor: "#303640", border: "1px solid #ffffff36", borderRadius:"5px", padding:"8px"}}>
              <label>Add the frequency to receive SMS: &nbsp;
                <input
                  type="number"
                  className="input-email"
                  value={this.state.sms_frequency}
                  onChange={(e) => (e.target.value)}
                  // placeholder={"Enter the frequency count"}
                  style={{
                    width: "55px",
                  }}
                />
              </label>
              </Box> */}
              {/* <div style={{ marginTop: "10px" }}> style={{ tableLayout: 'auto', width: '100%'}}*/}
              <TableContainer component={Paper} sx={{backgroundColor: "#303640", border: "1px solid #ffffff36", borderRadius:"5px"}}>
                <Table style={{ tableLayout: 'auto', width: '100%'}}>
                  <TableHead>
                    <TableRow>
                        {[
                        { label: 'Recipient', id: 'h-rec' },
                        { label: 'HDD Status', id: 'h-chm' },
                        { label: '30 Days Recording Status', id: 'h-recording' },
                        { label: 'Device Status', id: 'h-dev' },
                        // { label: 'RTSP Stream Status', id: 'h-stream' },
                        { label: 'True Threat Alerts', id: 'h-threat' },
                        { label: 'Clear Alerts', id: 'h-clear' }

                        ].map((header) => (
                        <TableCell key={header.id}>
                            <Typography variant="subtitle2" fontWeight="bold">
                            {header.label}
                            </Typography>
                        </TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(this.state.mob_numbers || []).map((mob, index) => ( 
                      <TableRow key={mob.id}>
                      <TableCell sx={{ display: "flex",gap: "5px", alignItems: "center" }}>
                        <div>
                          {/* Country Code Dropdown selection */}
                          <select
                            value={mob.countryCode || "+1"} // Default to +91 if not set
                            onChange={(e) => this.handleCountryCodeChange(index, e.target.value)}
                            style={{
                              backgroundColor: "#343c4d",
                              color: "#ffffff",
                              border: "1px solid #ffffff36",
                              borderRadius: "4px",
                              // padding: "0 5px",
                              height: "37px",
                              width: "100px",
                            }}
                          >
                            <option value="+91">+91 (IN)</option>
                            <option value="+1">+1 (US/CA)</option>
                            <option value="+44">+44 (UK)</option>
                            <option value="+61">+61 (AU)</option>
                          </select>
                      
                          <input
                            type="tel"
                            className="input-email"
                            value={mob.value}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, ""); // digits only
                              if (value.length <= 15) {
                                this.handleInputChange(index, value);
                              }
                            }}
                            placeholder={`Enter mob no. ${index + 1}`}
                            style={{
                              width: "280px",
                            }}
                          />
                          {/* Logic: Only show the '-' button if it is NOT the first row */}
                          {/* {index !== 0 && ( */}
                          <button
                            type="button"
                            onClick={() => this.removeEmailField(index)}
                            id="clearUserLogButton"
                            style={{
                              minWidth: "25px",
                              height: "30px",
                              flexShrink: 0        
                            }}
                          >
                            -
                          </button>
                          {/* )} */}
                        </div>
                      </TableCell>
                      <TableCell>
                          {/* HDD status */}
                          <Switch
                            checked={mob.hdd_status_enabled}
                            onChange={() => this.handleHddToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      
                      </TableCell>
                      <TableCell>
                        {/*  24hr Recording TOGGLE */}
                          <Switch
                            checked={mob.recording_status_enabled}
                            onChange={() => this.handleRordingStatusToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      </TableCell>
                      <TableCell>
                        {/* Device Status TOGGLE */}
                          <Switch
                            checked={mob.device_status}
                            onChange={() => this.handleDeviceStatusToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      </TableCell>
                        {/* RTSP Stream status */}
                      {/* <TableCell>
                          <Switch
                            checked={mob.rtsp_stream_enabled}
                            onChange={() => this.handleRtspStreamToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      </TableCell> */}
                      <TableCell>
                        {/*True Threat TOGGLE */}
                          <Switch
                            checked={mob.true_threat_enabled}
                            onChange={() => this.handleTrueThreatAlertStatusToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      </TableCell>
                      {/* Cleared Alerts */}
                      <TableCell>
                        {/*True Threat TOGGLE */}
                          <Switch
                            checked={mob.clear_alert_sms_enabled}
                            onChange={() => this.handleClearAlertStatusToggle(index)}
                            color="primary"
                            size="medium"
                            disabled={!mob.value}
                          />
                      </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="button"
                  onClick={this.addEmailField}
                  id="rowsPerPageButton"
                  style={{
                    minWidth: "25px",
                    // height:"34px",
                    marginTop: '12px'
                  }}
                >
                  + Add
                </Button>

                <Button id="rowsPerPageButton" style={{ marginTop: '12px' }}
                  onClick={this.handleSave}
                > Save
                </Button>

              </div>
              {/* </div> */}
            </div>
          </Box>
          {/* Backdrop with Circular Progress */}
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{ backgroundColor: '#001f54', borderRadius: '100px' }} />
            </div>
          </Backdrop>
        </Box>
      </ThemeProvider>
    ); 
  }
}

export default SmsNotificationsSettings;